<template>
  <div class="editorial-team-block">
    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon34.png" />
        <span>Editor in Chief, 首席编辑</span>
      </div>

      <div class="info">
        <img class="portrait" src="@/assets/imgs/Milesi.jpg" />
        <h2>Dr. Milesi, Earth Science Scientist 地球科学高级研究员</h2>
        <p>CropSnap LLC / NASA Ames Research Center (Former), Moffett Field, USA.</p>
        <p>Expertise: Remote Sensing, Ecosystem Modeling, Geography & Geospatial Technology.</p>
        <p>Montana(蒙塔纳)大学博士，国际著名地球科学专家、生态学家，美国硅谷CropSnap科技/科研服务公司创始人，前NASA AMES研究中心科学家。指导来自世界各国的硕士/博士生、访问学者数十位，与来自各国的作者合作发表大量SCI论文，本人Citation为3600多次，具有极其丰富的论文写作及润色经验。</p>
      </div>
    </div>

    <!-- <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon34.png" />
        <span>Chief Quality Control Officer，首席质量控制官</span>
      </div>

      <div class="info">
        <img class="portrait" src="@/assets/imgs/Schull.jpg" />
        <h2>Dr. Schull, Data Science Scientist 数据科学领域科学家</h2>
        <p>Earth System Science Interdisciplinary Center, University of Maryland (Former), USA.</p>
        <p>Expertise: Land and Hydrology, Data Fusion and Algorithm Development, Cloud Computing.</p>
        <p>波士顿大学博士、曾担任马里兰大学交叉学科中心研究科学家，研究方向为时空大数据与高性能地学计算，具有丰富且严格的论文质量控制经验。</p>
      </div>
    </div> -->

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon39.png" />
        <span>Domestic Editors, 学术对接顾问</span>
      </div>

      <div class="info">
        <h2>Dr. Liu-环境减灾、人类健康方向</h2>
        <p>清华大学助理研究员</p>

        <h2>Dr. Zeng-全球变化、生态学方向</h2>
        <p>美国斯坦福大学助理研究员</p>

        <h2>Dr. Yan-地理信息系统、计算机、地球科学方向</h2>
        <p>北师大遥感院研究生导师</p>

        <h2>Dr. Li-生物、医药方向</h2>
        <p>四川省肿瘤医院助理研究员</p>

        <h2>Dr. Wang-材料科学方向</h2>
        <p>北京航空航天大学助理研究员</p>
      </div>

      <div class="more-recruit">
        <img src="@/assets/imgs/icon45.png" />
        <span>更多对接编辑招募中</span>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon53.png" />
        <span>Editors of Native Speakers各专业副主编/优秀编辑代表</span>
      </div>

      <el-alert
        :closable="false"
        show-icon
        title="我们的编辑团队来自国外著名研究机构与知名大学。部分编辑专家的信息如下，如需了解更多专家信息，请邮件service@pandaedit.com 或者致电(15611822557) 联系我们的服务人员。"
        type="info"
      ></el-alert>

      <div class="info">
        <h2>Earth Science|地球科学/遥感/生态/环境科学等领域</h2>
        <ul>
          <li>
            <img class="portrait" src="@/assets/imgs/Milesi.jpg" />
            <h3>Dr. Milesi</h3>
            <p>CropSnap LLC / NASA Ames Research Center (Former), Moffett Field, USA.</p>
            <p>Expertise: Remote Sensing, Ecosystem Modeling, Geography & Geospatial Technology.</p>
            <img class="icon-click" src="@/assets/imgs/icon52.png" />
          </li>
          <li>
            <img class="portrait" src="@/assets/imgs/Heinsch.jpg" />
            <h3>Dr. Heinsch</h3>
            <p>US Forest Service (former), USA.</p>
            <p>Expertise: Remote Sensing, Fire, Phenology and Ecosystem Modeling.</p>
            <img class="icon-click" src="@/assets/imgs/icon52.png" />
          </li>
        </ul>

        <h2>Biology and Medicine|生物医学领域</h2>
        <ul>
          <li>
            <img class="portrait" src="@/assets/imgs/Mandelli.png" />
            <h3>Dr. Mandelli</h3>
            <p>University of California, Los Angeles (Former), USA</p>
            <p>Expertise: Molecular, Cell, and Developmental Biology</p>
            <img class="icon-click" src="@/assets/imgs/icon52.png" />
          </li>
          <li>
            <img class="portrait" src="@/assets/imgs/Dasari.png" />
            <h3>Dr. Dasari</h3>
            <p>Scripps College</p>
            <p>Expertise: Molecular Biology</p>
            <img class="icon-click" src="@/assets/imgs/icon52.png" />
          </li>
        </ul>

        <h2>Material Science|材料化学领域</h2>
        <ul>
          <li>
            <img class="portrait" src="@/assets/imgs/Bista.jpg" />
            <h3>Dr. Bista</h3>
            <p>Oregon State University (Former), USA</p>
            <p>Expertise: Biogeochemical Modeling, Agroecosystems, Greenhouse Gas Emissions, Sustainable Agriculture</p>
            <img class="icon-click" src="@/assets/imgs/icon52.png" />
          </li>
          <li>
            <h3>Dr. Baker</h3>
            <p>The University of Maryland Atmospheric and Oceanic Sciences, College Park, Maryland, USA.</p>
            <p>Expertise: Modeling Land-Atmosphere Exchange, Boundary Layer Dynamics, Earth System Modeling.</p>
            <img class="icon-click" src="@/assets/imgs/icon52.png" />
          </li>
        </ul>

        <h2>Computer Science and Big Data|计算机科学与大数据领域</h2>
        <ul>
          <li>
            <img class="portrait" src="@/assets/imgs/Schull.jpg" />
            <h3>Dr. Schull</h3>
            <p>Earth System Science Interdisciplinary Center, University of Maryland (Former), USA.</p>
            <p>Expertise: Land and Hydrology, Data Fusion and Algorithm Development, Cloud Computing</p>
            <img class="icon-click" src="@/assets/imgs/icon52.png" />
          </li>
        </ul>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon42.png" />
        <span>Invitation to Join in the Paid Part-time Online Language Polishing Editors|兼职编辑招募</span>
      </div>

      <div class="info">
        <h3>
          If you know someone who are English native-speakers and have the potential to be the language polishing editors, please ask them to email 
          <a
            @click="toAbout"
            href="javascript:;"
          >hr@pandaedit.com</a> or contact us by +86 15611822557. For the detailed description of the editor hiring information, please 
          <a
            :href="clickHere"
            target="_blank"
          >click here</a>. 若您认识海外专家认可我们的C2C科研服务模式，有意兼职担任论文编辑，请发送邮件到
          <!-- :href="emailLink" -->
          <!-- target="_blank" -->
          <a @click="toAbout" href="javascript:;">hr@pandaedit.com</a> 或者电话+86 15611822557 联系我们。详细的招聘信息，请 
          <a :href="clickHere" target="_blank">点击这里</a>。
        </h3>
        <h3>
          Please download and fill in the 
          <a
            :href="pdfDownload"
            target="_blank"
          >Language-Editor-Application</a>
          form, and then send it to
          <a
            @click="toAbout"
            href="javascript:;"
          >hr@pandaedit.com</a>. Our Editor in Chief will evaluate your background and contact with you. 请点击下载并填写我们的 
          <a
            :href="pdfDownload"
            target="_blank"
          >兼职编辑信息表</a>，并发送至
          <a @click="toAbout" href="javascript:;">hr@pandaedit.com</a>，我们的主编将对您的材料进行审核并组织面试和培训。
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 论文润色 - 样例与反馈
 */
// import * as api from '@/api/login'

export default {
  name: 'EditorialTeam',
  data() {
    return {
      clickHere: '',
      emailLink: '',
      pdfDownload: '',
    }
  },
  created() {
    this.clickHere = this.$store.state.user.urlLink + 'LE-Hiring'
    this.pdfDownload = this.$store.state.user.urlLink + 'model/Language-Editor-Registration-final_web_Insider_v6.pdf'
  },
  methods: {
    /**
     * @description 跳转到关于我们
     */
    toAbout() {
      this.$router.push({
        path: '/about',
      })
    },

    //     /**
    //  * @description 获取角色列表
    //  */
    // getListByPage() {
    //   const _this = this
    //   _this.tableLoading = true
    //   const _param = {
    //     page: _this.pageparm.page,
    //     size: _this.pageparm.size,
    //     roleName: _this.pageparm.roleName,
    //     orgid: _this.pageparm.orgid
    //   }
    //   api.listByPage(_param)
    //     .then(res => {
    //       const data = res.data
    //       _this.tableLoading = false
    //       _this.listData = data.result
    //       _this.pageparm.total = data.pageTotalCount
    //     })
    //     // .catch(err => {
    //     // })
    // },
  },
}
</script>
<style lang="scss" scoped>
.editorial-team-block {
  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 0 0 40px 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }
    }

    .info {
      padding: 0 20px;

      .portrait {
        width: 200px;
        margin: 15px 0 0 0;
        display: block;
      }

      ul,
      li {
        margin: 0;
        padding: 0;
        list-style-type: none;
      }

      li {
        border-top: 1px solid #f8f9f9;
        border-bottom: 1px solid #f8f9f9;
        padding: 15px 0;
        overflow: hidden;

        .portrait {
          margin: 0;
        }

        .icon-click {
          margin: 15px 0 0 0;
          float: right;
          cursor: pointer;
        }
      }

      p {
        color: #98a5a6;
        line-height: 1.6;
        margin: 0;
      }

      a {
        color: $colorNormal;
      }
    }

    /deep/.el-alert {
      margin: 15px 0;

      .el-alert__title {
        font-size: 14px;
        font-weight: bold;
      }
    }

    .more-recruit {
      margin: 15px 0 0 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      img {
        display: block;
        height: 20px;
        margin: 0 10px 0 0;
      }
    }
  }
}
</style>